<template>
  <div :class="$style.footer">
    <div :class="$style.infoWrapper">
      <div :class="$style.info">
        <div :class="$style.contact">联系我们</div>
        <div :class="$style.contactInfo">
          <div :class="$style.phone">联系电话: 18600430890</div>
          <div :class="$style.email">电子邮箱: hezuo@geekbang.com </div>
        </div>
      </div>
    </div>
    <div :class="$style.copyright">
      <p>Copyright © {{ new Date().getFullYear() }} The Holding of GeekBang (Beijing) Co</p>
      <p>Ltd. 极客邦控股(北京)有限公司 </p>
      <p>
        <a href="https://beian.miit.gov.cn" target="_blank">京 ICP 备 16027448号-{{ topDomain === 'com' ? '4' : '3' }}.</a>
        <img :class="$style.policeImg" src="https://static001.geekbang.org/static/time/img/geek_elements/beian.png">
        <a :class="$style.police" href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=11010502037384" target="_blank">
          京公网安备 11010502037384 号.
        </a>
      </p>
      <p>
        <a href="https://static001.geekbang.org/resource/image/ab/da/ab70c7be273a305a91a3c6f5370869da.png">增值电信业务经营许可证</a>
        <a :class="$style.jingwangwen" href="https://static001.geekbang.org/resource/image/ab/7b/ab0fad9c05fc91d5b1819da6d449137b.jpg" target="_blank">京网文[2019]6009-706号</a>
      </p>
    </div>
  </div>
</template>

<script>
import { topDomain } from '@/config'

export default {
  data () {
    return {
      topDomain
    }
  }
}
</script>

<style lang="scss" module>
.infoWrapper {
  width: 100%;
  height: 154px;
  background: url(../../../assets/img/home/black-bg.png) no-repeat center;
  background-size: cover;
}

.info {
  padding: 30px 15px;
}

.contact {
  font-size: 16px;
  font-weight: 500;
  color: #FFFFFF;
  line-height: 22px;
}

.contactInfo {
  margin-top: 16px;
}

.phone,
.email {
  font-size: 14px;
  font-weight: 400;
  color: #FFFFFF;
  line-height: 28px;
  opacity: .8;
}

.copyright {
  display: flex;
  flex-direction: column;
  align-items: center;
  box-sizing: border-box;
  padding: 20px;
  background: linear-gradient(180deg, #FFFBF7 0%, #FBF9F5 100%);
  font-size: 11px;
  font-weight: 400;
  color: #888888;
  line-height: 11px;

  p {
    display: flex;
    align-items: center;
    margin-bottom: 7px;
  }
}

.policeImg {
  margin-left: 3px;
  margin-right: 3px;
  width: 14px;
  height: 14px;
}

.jingwangwen {
  margin-left: 4px;
}
</style>
